var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title-con" }, [
        _c("div", { staticClass: "return-btn-con" }, [
          _c(
            "button",
            {
              staticClass: "return-btn",
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _c("c-svg", {
                attrs: {
                  src: "return.svg",
                  width: "21",
                  height: "21",
                  fill: "rgb(217, 222, 229)",
                },
              }),
              _c("div", { staticClass: "text" }),
            ],
            1
          ),
        ]),
        _c("h1", { staticClass: "case-title" }, [_vm._v("五五盲盒")]),
        _c("div", { staticClass: "block" }),
      ]),
      !_vm.$screen.mobile
        ? _c(
            "div",
            { ref: "case_cate_sel", staticClass: "case-category-con" },
            [
              _c("div", { staticClass: "case-price-con" }, [
                _c("div", { staticClass: "title" }, [_vm._v("按价格筛选:")]),
                _c("div", { staticClass: "case-price" }, [
                  _c(
                    "div",
                    {
                      staticClass: "price-item",
                      class: { active: _vm.price_range_index == 0 },
                      on: {
                        click: function ($event) {
                          _vm.price_range_index = 0
                        },
                      },
                    },
                    [_vm._v("所有箱子 ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "price-item",
                      class: { active: _vm.price_range_index == 1 },
                      on: {
                        click: function ($event) {
                          _vm.price_range_index = 1
                        },
                      },
                    },
                    [_vm._v("0 — 1 ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "price-item",
                      class: { active: _vm.price_range_index == 2 },
                      on: {
                        click: function ($event) {
                          _vm.price_range_index = 2
                        },
                      },
                    },
                    [_vm._v("2 — 19 ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "price-item",
                      class: { active: _vm.price_range_index == 3 },
                      on: {
                        click: function ($event) {
                          _vm.price_range_index = 3
                        },
                      },
                    },
                    [_vm._v("20 — 49 ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "price-item",
                      class: { active: _vm.price_range_index == 4 },
                      on: {
                        click: function ($event) {
                          _vm.price_range_index = 4
                        },
                      },
                    },
                    [_vm._v("50 — 99 ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "price-item",
                      class: { active: _vm.price_range_index == 5 },
                      on: {
                        click: function ($event) {
                          _vm.price_range_index = 5
                        },
                      },
                    },
                    [_vm._v("100+ ")]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._l(
        _vm.cateCaseCategory,
        function (cases_category, cases_category_index) {
          return _c(
            "section",
            {
              ref: "caseloc" + cases_category_index,
              refInFor: true,
              staticClass: "cases-con",
              class: "cate-" + cases_category_index,
            },
            [
              _c("div", { staticClass: "case-title" }, [
                _c("h2", { staticClass: "text" }, [
                  _vm._v(" " + _vm._s(cases_category) + " "),
                ]),
              ]),
              _c("h1", { staticClass: "sell-icon" }, [_vm._v("CS:GO 箱子")]),
              _vm.$screen.mobile
                ? _c(
                    "div",
                    { staticClass: "case-con" },
                    _vm._l(
                      _vm.cateCaseList(cases_category).slice(-1),
                      function (case_item, case_item_index) {
                        return _c(
                          "a",
                          { key: case_item_index, staticClass: "case" },
                          [
                            _c("div", { staticClass: "case-img-con" }, [
                              _c("div", [
                                _c("div", { staticClass: "case-img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$imgfilter(case_item.casePic),
                                    },
                                  }),
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$imgfilter(case_item.itemPic),
                                    },
                                  }),
                                ]),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "case-price" },
                              _vm._l(
                                _vm.cateCaseList(cases_category),
                                function (case_price, index_price) {
                                  return _c(
                                    "span",
                                    {
                                      key: index_price,
                                      staticClass: "case-price-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.pathGo({
                                            name: "exclusiveDetail",
                                            params: case_price,
                                            id: case_price.caseId,
                                            category: cases_category,
                                          })
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("conversion")(case_price.price)
                                        ) + " "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _c(
                    "div",
                    { staticClass: "case-con" },
                    _vm._l(
                      _vm.cateCaseList(cases_category),
                      function (case_item, case_item_index) {
                        return _c(
                          "a",
                          {
                            key: case_item_index,
                            staticClass: "case",
                            on: {
                              click: function ($event) {
                                return _vm.pathGo({
                                  name: "exclusiveDetail",
                                  params: case_item,
                                  id: case_item.caseId,
                                  category: cases_category,
                                })
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "case-img-con" }, [
                              _c("div", [
                                _c("div", { staticClass: "case-img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$imgfilter(case_item.casePic),
                                    },
                                  }),
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$imgfilter(case_item.itemPic),
                                    },
                                  }),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticClass: "case-name" }, [
                              _vm._v(_vm._s(case_item.caseName)),
                            ]),
                            _c("div", { staticClass: "case-price-btn" }, [
                              _vm._v(
                                _vm._s(_vm._f("conversion")(case_item.price)) +
                                  " "
                              ),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
            ]
          )
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }